import React from "react";
import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-media" aria-hidden="true">
        <img
          src="/images/hero.jpg"
          alt=""
          className="hero-image"
          width={1920}
          height={1080}
          decoding="async"
          fetchPriority="high"
        />
      </div>
      <div className="container hero-content">
        <div className="hero-card">
          <p className="hero-kicker">{t("hero.kicker")}</p>
          <h1 className="hero-title">
            {t("hero.titleLine1")}
            <br />
            <span>{t("hero.titleLine2")}</span>
          </h1>
          <p className="hero-subtitle">{t("hero.subtitle")}</p>
          <div className="hero-actions">
            <button className="btn primary" onClick={() => scrollTo("tours")}>
              {t("hero.ctaPrimary")}
            </button>
            <button className="btn ghost" onClick={() => scrollTo("contact")}>
              {t("hero.ctaSecondary")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
